<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-card>
    <v-toolbar card color="white">
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat icon @click="filter.year--">
          <v-icon>arrow_left</v-icon>
        </v-btn>
        <v-text-field
          prepend-icon="date_range"
          :label="$t('year')"
          type="number"
          v-model="filter.year"
          :single-line="true"
        ></v-text-field>
        <v-btn flat icon @click="filter.year++">
          <v-icon>arrow_right</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="coefficientReadinessYearly"
        :loading="coefficientReadinessIsLoading"
        class="elevation-1"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <td><au-vehicle :vehicle="props.item.vehicle" /></td>
          <td>
            <span v-if="props.item.inaccessibility_in_hours === 8000">
              Zliczanie pominięte – przegląd P4 wykonano w poprzednich latach.
            </span>
            <span v-else>
              {{ props.item.inaccessibility_in_hours }}
            </span>
          </td>

          <td>
            <span v-if="props.item.inaccessibility_in_hours === 8000">
              Nie dotyczy
            </span>
            <span v-else>
              {{ props.item.vehicle_readiness | percent }}
            </span>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_COEFFICIENT_READINESS_YEARLY } from "@/store/actions.type";
import refreshButtonMixin from "@/mixins/refreshButton.mixin";

export default {
  data() {
    return {
      filter: {
        year: new Date().getFullYear(),
      },
      headers: [
        { text: this.$t("vehicle"), value: "vehicle" },
        {
          text: this.$t("inaccessibilityInHours"),
          value: "inaccessibility_in_hours",
        },
        { text: this.$t("vehicleReadiness"), value: "vehicle_readiness" },
      ],
    };
  },
  computed: {
    ...mapGetters(["coefficientReadinessYearly", "coefficientReadinessIsLoading"]),
  },
  watch: {
    filter: {
      handler: function () {
        this.fetchItems();
      },
      deep: true,
    },
  },
  mixins: [refreshButtonMixin],
  methods: {
    fetchItems() {
      this.$store.dispatch(FETCH_COEFFICIENT_READINESS_YEARLY, this.filter.year);
    },
  },
  created() {
    this.fetchItems();
  },
};
</script>

<style scoped></style>
